import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {Box, Card, CardContent, CardMedia, Dialog, DialogContent, Grid, IconButton, Typography} from "@mui/material";
import {useState} from "react";
import ComingSoon from "../../../../components/ComingSoon";
import HelpSidebar from "../../../../components/HelpSidebar";
import { TUTORIAL_VIDEO_FOLDER, tutorialVideoUrl } from "app/utils/constants/tutorialVideos";

const { SHARED, DOCGEN } = TUTORIAL_VIDEO_FOLDER;

let videosToRender = {
  "Admin": [
    { title: "How to manage user access ?", src: tutorialVideoUrl(SHARED, "Managing+Access.mp4") },
  ],
  "Getting Started": [
    { title: "Docgen Complete Tutorial", src: tutorialVideoUrl(DOCGEN, "docgen_complete_tutorial.mp4") },
  ],
  "XFA and Custom Forms": [
    { title: "XFA and Custom Forms", src: tutorialVideoUrl(DOCGEN, "docgen_xfa_custom_forms_tutorial.mp4") },
  ],
  "Category Management": [
    { title: "Docgen Category Management", src: tutorialVideoUrl(DOCGEN, "docgen_category_management_tutorial.mp4") },
  ]
};

const TutorialSection = () => {
  const [open, setOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  let sidebarItems = [
    { label: "Admin", subMenus: [], subKey: "" },
    { label: "Getting Started", subMenus: [], subKey: "" },
    { label: "XFA and Custom Forms", subMenus: [], subKey: "" },
    { label: "Category Management", subMenus: [], subKey: "" },
  ];

  if (localStorage.getItem("TENANT_ROLE") === "user") {
    sidebarItems = sidebarItems.slice(1);
    sidebarItems.pop()
  }

  const [tab, setTab] = useState(sidebarItems[0]?.label || "");

  const handleOpenVideo = (video) => {
    setSelectedVideo(video);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVideo(null);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        height: "100%",
        minHeight: 0,
        bgcolor: "#f5f8fc",
        py: 2,
        overflow: "hidden",
      }}
    >
      {/* Sidebar column */}
      <Grid
        item
        xs={12}
        md={3}
        sx={{
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden", 
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
              scrollbarGutter: "stable",
            }}
          >
            <HelpSidebar
              sidebarItems={sidebarItems || []}
              tab={tab}
              setTab={setTab}
            />
          </Box>
        </Box>
      </Grid>

      {/* Video content column */}
      <Grid
        item
        xs={12}
        md={9}
        sx={{
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              p: 4,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
            }}
          >
            {videosToRender?.[tab]?.length ? <Grid container spacing={4}>
              {(videosToRender?.[tab] || []).map((video, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 2,
                      boxShadow: "none",
                      border: "0.5px solid #e0e0e0",
                      height: "100%",
                    }}
                  >
                    <CardMedia component="div" sx={{ height: 180, position: "relative" }}>
                      <img
                        src="/images/june/june-demo.png"
                        alt={video.title}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                      <IconButton
                        onClick={() => handleOpenVideo(video)}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "white",
                          backgroundColor: "rgba(0,0,0,0.4)",
                          "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
                        }}
                      >
                        <PlayCircleOutlineIcon fontSize="large" />
                      </IconButton>
                    </CardMedia>

                    <CardContent
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        textAlign: "left",
                        backgroundColor: "white",
                        p: 2
                      }}
                    >
                      <Typography variant="body1">{video.title}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid> : <ComingSoon />}
          </Box>
        </Box>
      </Grid>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogContent sx={{ p: 0 }}>
          {selectedVideo && (
            <video
              src={selectedVideo.src}
              controls
              autoPlay
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "4px",
                outline: "none",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default TutorialSection;